import React, { Fragment } from "react";
import { Row, Col } from "reactstrap";
import Skeleton from '@mui/material/Skeleton';
import classes from "./TruckCounts.module.scss";
import Section from "../../../general/Section/Section";

import truckInventoryIcon from './../../../../assets/icons/truck-inventory.svg'; 

import TrucksOnCampaignIcon from "../../../../assets/icons/components/TrucksOnCampaignIcon";
import TruckInventoryIcon from "../../../../assets/icons/components/TruckInventoryIcon";
import { boxiPrimary } from "../../../../assets/style/colors";

const TruckCount = (props) => {
  return (
    <Row className="mt-4">
      <Col xs="5">
        <div className={classes.cardContainer}>
          <div className={classes.cardInner}>
            <div className={classes.cardHeading}>
              Trucks on Campaign
            </div>
            <div className={classes.cardIcon}>
              <TrucksOnCampaignIcon color={boxiPrimary} />
            </div>
          </div>
          {props.isLoading ? 
            <Skeleton variant="text" height={45} width={60} sx={{ fontSize: '1rem' }} />
            :
            <div className={classes.count}>{props.campaignTrucks}</div>
          }
        </div>
      </Col>
      <Col xs="5">
        <div className={classes.cardContainer}>
          <div className={classes.cardInner}>
            <div className={classes.cardHeading}>
              Truck Inventory
            </div>
            <div className={classes.cardIcon}>
              <TruckInventoryIcon color={boxiPrimary} />
            </div>
          </div>
          {props.isLoading ? 
            <Skeleton variant="text" height={45} width={60} sx={{ fontSize: '1rem' }} />
            :
            <div className={classes.count}>{props.truckInventory}</div>
          }
        </div>
      </Col>
      {/* <Col xs="4">
        <Section>
          <div className={classes.label}>
            Trucks On
            <br />
            Track
          </div>
          <div className={classes.count}>{props.trucksOnTrack}</div>
        </Section>
      </Col> */}
    </Row>
  );
};

export default TruckCount;
